var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-button',{attrs:{"big":"","fill":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('p',[_c('icon',{attrs:{"name":"check"}})],1),_c('label',[_vm._v("送信する")])])
}
var staticRenderFns = []

export { render, staticRenderFns }